import type { FallbackRender } from '@sentry/react';

import { Button } from '@components/ui/button';

export const errorFallback: FallbackRender = ({ eventId, resetError }) => (
  <div className="grid h-screen place-content-center gap-3 p-6 text-center">
    <p className="text-lg font-semibold">Something went wrong</p>
    <p className="text-sm text-gray-500">
      The error has been reported. Please try again.
    </p>
    {eventId && <p className="text-xs text-gray-400">Reference: {eventId}</p>}
    <Button className="justify-self-center" onClick={resetError}>
      Try again
    </Button>
  </div>
);
